import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  CircularProgress
} from "@mui/material";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSPhone from "../../Components/Phone/WSPhone";
import WSButton from "../../Components/Button/WSButton";
import { WSIcons } from "../../commonFunctions/iIcons";
import {
  callAPI,
  clearRequest,
  Method
} from "../../commonFunctions/CommonFunctions";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import {
  HeaderList,
  IHeaderListActions
} from "../../Components/Header/HeaderList";
import WSFileUpload from "../../Components/FileUpload/WSFileUpload";

const FranchiseRegistration: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { handleSubmit, setValue, control } = useForm();

  const { showMessage } = useSnackbar();
  const [loading, setLoading] = useState(true); // Loading state
  const [defaultImg, setDefaultImg] = useState<any | null>(null);

  useEffect(() => {
    async function getData() {
      try {
        const response: any = await callAPI("franchises", Method.GET, null, id);

        if (response.success) {
          setValue("name", response.data.name);
          setValue("contactNumber", response.data.contactNumber);
          setValue("owner", response.data.owner);
          setValue("location", response.data.location);

          //address;
          setValue("addressLine1", response.data.addressLine1);
          setValue("addressLine2", response.data.addressLine2);
          setValue("state", response.data.state);
          setValue("city", response.data.city);
          setValue("pincode", response.data.pincode);
          setDefaultImg(response.data.logoUrl);
        }
      } catch (error) {
        console.error("API call failed:", error);
        showMessage("Something went wrong. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    }
    if (id) {
      getData();
    }
  }, [id, setValue]);

  const onSubmit = async (data: any) => {
    
    try {
      const formData = new FormData();

      // Append text fields
      formData.append("name", data.name);
      formData.append("owner", data.owner);
      formData.append("location", data.location);
      formData.append("contactNumber", data.contactNumber);
      formData.append("addressLine1", data.addressLine1);
      formData.append("addressLine2", data.addressLine2);
      formData.append("state", data.state);
      formData.append("city", data.city);
      formData.append("pincode", data.pincode);

      // Append file
      if (data.logo && data.logo.length > 0) {
        formData.append("logo", data?.logo[0] || null); // Ensure "Logo" matches cURL field name
      }

      const endpoint = id ? `franchises/update/${id}` : "franchises/create";
      const method = id ? Method.PUT : Method.POST;

      const response: any = await callAPI(endpoint, method, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (response) {
        showMessage(response?.message, response.success ? "success" : "error");
        if (response.success) navigate("/franchise/list");
      }
    } catch (e: any) {
      console.error("API call failed:", e);
      showMessage(e.message, "error");
    }
  };

  const handleCancelClick = () => {
    navigate("/franchise/list");
  };
  const actions: IHeaderListActions[] = [
    {
      type: "icon",
      text: "Cancel",
      size: "small",
      onClick: handleCancelClick,
      variant: "outlined",
      color: "error",
      icon: <WSIcons.CancelIcon />
    },
    {
      type: "icon",
      text: "Save",
      size: "small",
      buttonType: "submit",
      variant: "outlined",
      color: "success",
      icon: <WSIcons.SaveIcon />
    }
  ];

  const handleUploadFile = (file: any) => {
    setDefaultImg(null);
    // if (file && file.length > 0) {
    //   setSelectedFile(file[0]);
    // }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <HeaderList title="Add Franchisee" type="card" actions={actions} />
      <Card sx={{ padding: 2, borderRadius: 2 }}>
        {/* <Grid  sx={{ border: '1px solid red', padding: 1, borderRadius: 2 }}> */}

        <Grid
          item
          container
          spacing={1}
          justifyContent={"start"}
          sx={{
            marginTop: 0,
            marginLeft: 0,
            width: "100%",
            backgroundColor: "#7D79C2",
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5
          }}
        >
          <Grid
            alignContent={"center"}
            style={{ paddingLeft: 20, paddingTop: 0, height: "3rem" }}
            item
            sm={4}
            className="ws-data-grid-lightviolet-title"
          >
            <Typography variant="h6" id="tableTitle" sx={{ fontSize: "1rem" }}>
              Franchisee Information
            </Typography>
          </Grid>
        </Grid>
        <Grid
          sx={{
            padding: 3,
            backgroundColor: "#fff",
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
            border: "1px solid lightgrey"
            // marginTop: 3,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <WSTextField
                id="name"
                name="name"
                control={control}
                label={"Franchise Name"}
                rules={{ required: "please enter name of franchise" }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                id="owner"
                name="owner"
                control={control}
                label={"Owner"}
                rules={{ required: "please enter owner name" }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                id="location"
                name="location"
                control={control}
                label={"Location"}
                rules={{ required: "please choose a location" }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSPhone
                id="contactNumber"
                name="contactNumber"
                label={"Phone Number"}
                control={control}
              />
            </Grid>

            <Grid item sm={12} style={{ overflow: "auto" }}>
              <WSFileUpload
                name="logo"
                label="Franchise Logo"
                control={control}
                rules={{ required: defaultImg ? false : true }}
                acceptFileTypes=".jpg,.jpeg,.png"
                maxFileSizeMB={2}
                defaultValue={defaultImg}
                id={"logo"}
                image={true}
                onChange={handleUploadFile}
                align="Start"
                isToolTipImg={false}
                multiple={false}
              />
            </Grid>
          </Grid>
        </Grid>
      </Card>
      <Card sx={{ padding: 2, borderRadius: 2, marginTop: 2 }}>
        {/* <Grid  sx={{ border: '1px solid red', padding: 1, borderRadius: 2 }}> */}

        <Grid
          item
          container
          spacing={1}
          justifyContent={"start"}
          sx={{
            marginTop: 0,
            marginLeft: 0,
            width: "100%",
            backgroundColor: "#7D79C2",
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5
          }}
        >
          <Grid
            alignContent={"center"}
            style={{ paddingLeft: 20, paddingTop: 0, height: "3rem" }}
            item
            sm={4}
            className="ws-data-grid-lightviolet-title"
          >
            <Typography variant="h6" id="tableTitle" sx={{ fontSize: "1rem" }}>
              Address Details
            </Typography>
          </Grid>
        </Grid>
        <Grid
          sx={{
            padding: 3,
            backgroundColor: "#fff",
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
            border: "1px solid lightgrey"
            // marginTop: 3,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <WSTextField
                id="addressLine1"
                name="addressLine1"
                label={"Address Line1"}
                rules={{ required: "address is required" }}
                control={control}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                id="addressLine2"
                name="addressLine2"
                label={"Address Line2"}
                control={control}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                id="state"
                name="state"
                rules={{ required: "state is required" }}
                label={"State"}
                control={control}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                id="city"
                name="city"
                rules={{ required: "city is required" }}
                label={"City"}
                control={control}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                id="pincode"
                name="pincode"
                rules={{ required: "pincode is required" }}
                label={"Pincode"}
                control={control}
              />
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </form>
  );
};

export default FranchiseRegistration;
